export default __webpack_public_path__ + "static/media/googleIcon.a2a9c863.svg";